import { Injectable } from '@angular/core';
import { ILanguage, IVoice } from 'src/app/core/interfaces';
import { getLangsList } from './defaultLanguagesData';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor() { }

  get availableLanguages(): ILanguage[] { return getLangsList().concat(); }

  get availableLangCodesForUI(): string[] {
    return getLangsList().concat().filter(l => l.availableForUI).map(l => l.code);
  }

  getLangById(langId: number): ILanguage | null {
    return langId && langId >= 0 ?
      getLangsList().concat().find(x => x.msLangIds.some(id => id === langId)) || null : null;
  }

  getLangByCode(langCode: string | null): ILanguage | null {
    if (langCode === null) {
      return null;
    }

    return langCode && langCode >= '' ? getLangsList().concat().find(x => x.code === langCode) || null : null;
  }

  getLangByVoice(voiceName: string): ILanguage | null {
    return this.availableLanguages.find(x => !!x.voices.find(v => v.name === voiceName)) || null;
  }

  getDefaultVoiceByLangCode(langCode: string): IVoice | null | undefined {
    const result = langCode && langCode >= '' ? this.availableLanguages.find(x => x.code === langCode) || null : null;
    return result !== null ? result.voices.find(x => x.isDefault) : null;
  }

  getVoiceByName(voiceName: string | null): IVoice | null {
    let voices: IVoice[] = [];

    if (!voiceName || voiceName === '') {
      return null;
    }

    this.availableLanguages.forEach(x => { voices = voices.concat(x.voices); });
    return voices.find(x => x.name === voiceName) || null;
  }

  getLangByCodeSafe(langCode: string): ILanguage | null {
    let lang = this.getLangByCode(langCode);

    if (lang === null) {
      lang = this.getLangByCode(environment.defaultLangCode);
    }

    return lang;
  }

  getVoiceNameAndLocale(voiceName: string): string {
    const voice = this.getVoiceByName(voiceName);
    if (voice) {
      return voice.nativeName + ' (' + voice.locale.substring(3, 5) + ')';
    }
    return '';
  }
}
